import React, { Fragment } from 'react';
import styled from 'styled-components';
import theme from '../../theme';

const LabelWrapper = styled.label`
    position: absolute;
    right: ${theme('layout.hamburgerHeight')};
    top: 0px;
    bottom: 0;
    z-index: 10;
    cursor: pointer;
    margin: auto;
    height: ${theme('layout.hamburgerHeight')};
    @media (min-width: ${theme('layout.pageWidth')})  {
      display: none;
    }
`;

const HiddenInput = styled.input`
  opacity: 0;
  position: absolute;
  &:checked ~ label span:first-child {
    transform: rotate(-45deg) translate(-5px, 5px);
  }
  &:checked ~ label span:nth-child(2) {
    opacity: 0;
  }
  &:checked ~ label span:last-child {
    transform: rotate(45deg) translate(-5px, -5px);
  }
  &:checked ~ nav {
    display: flex;
    background-color: ${theme('colors.backgroundLight')};
  }
`;

const IconLine = styled.span`
    width: 22px;
    height: 3px;
    background-color: ${theme('colors.accentSecondary')};
    display: block;
    border-radius: 1.5px;
    margin: 4px 0px;
    transition: all 0.4s ease 0s;
  `;

export default () => (
  <Fragment>
    <HiddenInput type="checkbox" id="nav-hamburger" name="hamburger" />
    <LabelWrapper htmlFor="nav-hamburger">
      <IconLine />
      <IconLine />
      <IconLine />
    </LabelWrapper>
  </Fragment>
);
